/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScenarioVersionParameterType {
    NUMERIC = 'NUMERIC',
    PERIOD = 'PERIOD',
    ARRAY = 'ARRAY'
}


export function instanceOfInternalApiScenarioVersionParameterType(value: any): boolean {
    for (const key in InternalApiScenarioVersionParameterType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScenarioVersionParameterType, key)) {
            if (InternalApiScenarioVersionParameterType[key as keyof typeof InternalApiScenarioVersionParameterType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScenarioVersionParameterTypeFromJSON(json: any): InternalApiScenarioVersionParameterType {
    return InternalApiScenarioVersionParameterTypeFromJSONTyped(json, false);
}

export function InternalApiScenarioVersionParameterTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioVersionParameterType {
    return json as InternalApiScenarioVersionParameterType;
}

export function InternalApiScenarioVersionParameterTypeToJSON(value?: InternalApiScenarioVersionParameterType | null): any {
    return value as any;
}

export function InternalApiScenarioVersionParameterTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScenarioVersionParameterType {
    return value as InternalApiScenarioVersionParameterType;
}

